import { s } from '@/theme/tokens';
import { tableV2ChevronColumnWidth } from './TableV2Constants';
import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2ChevronCellSx = {
  maxWidth: tableV2ChevronColumnWidth,
  minWidth: tableV2ChevronColumnWidth,
  p: s('none'),
  position: 'relative',
  verticalAlign: 'middle',
  width: tableV2ChevronColumnWidth,
} satisfies SxProps<Theme>;
